<div class="container"
    style="display: flex; justify-content: center; flex-direction: column; align-items: center; height: 100vh;"
>

    <p 
        class="text-center"
        style="font-size: 1.2em;"    
    >
        Buen día {{ firstName }}, Por favor ingresa la contraseña temporal que te fue enviada y a continuación crea una nueva para acceder a tu cuenta.
    </p>

    <br/><br/>

    <div
        class="w-100"
    >
        <app-form-change-password
            [userId]="userId"
            [userName]="userName"
            [returnToAdmin]="true"
        ></app-form-change-password>
    </div>

    <div>
        <div class="form-group"
             style="margin-top: 6em;"
        >
            <button class="btn btn-danger"
                (click)="logout()"
            >
                <i class="fa fa-arrow-left"></i>
                Iniciar sesión
            </button>

        </div>
    </div>
    

</div>



